import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, { VListItem, VTab, VTreeview, VBtn } from 'vuetify/lib'

Vue.use(Vuetify, {
  // Load components not found by Vuetify Loader Plugin (initialized in /webpack.config.js)
  components: {
    VListItem,
    VTab,
    VTreeview,
    VBtn
  }
})

const opts = {}

export default new Vuetify(opts)